module.exports = __webpack_public_path__ + "img/IFPI-logo-Whiteblack.ec858878.svg";